// src/components/LeftSidebar.jsx
import React, { useState, useContext } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { ThemeContext } from '../contexts/ThemeContext';
import { useWeb3 } from '../contexts/Web3Context'; // Added useWeb3

import { useUser } from '../contexts/UserContext';
import { FaUserShield } from 'react-icons/fa';

// --- Logos ---
import logoLight from '../assets/logo_plateado.png';
import logoDark from '../assets/logo_transparente.png';
import iconLight from '../assets/icono_plateado.png';
import iconDark from '../assets/icono.png';

// --- Iconos del Menú ---
import dashboardIconUrl from '../assets/dashboard_icon.png';
import mercadoIconUrl from '../assets/market_icon.png';
import comprarVenderIconUrl from '../assets/buy-sell_icon.png';
import estadoXCoinIconUrl from '../assets/icono_plateado.png';
import billeteraIconUrl from '../assets/wallet_icon.png';
import balanceIconUrl from '../assets/balance_icon.png';
import depositarIconUrl from '../assets/deposit_icon.png';
import graficosIconUrl from '../assets/grafic_icon.png';
import noticiasIconUrl from '../assets/News_icon.png';
import packageJson from '../../package.json';

const LeftSidebar = ({ isCollapsed }) => {
  const { theme } = useContext(ThemeContext);
  const { userData } = useUser();
  const { disconnectWallet } = useWeb3();
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);

  const handleMenuClick = (menuName) => {
    if (!isCollapsed) {
      setOpenMenu(openMenu === menuName ? null : menuName);
    }
  };

  const handleMouseEnter = (menuName) => {
    if (isCollapsed) {
      setOpenMenu(menuName);
    }
  };

  const handleMouseLeave = () => {
    if (isCollapsed) {
      setOpenMenu(null);
    }
  };

  return (
    <aside className={`left-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <a href="https://xcoin.cl" className="sidebar-logo" title="Volver al Inicio">
        {isCollapsed ? (
          <>
            {theme === 'dark' ? (
              <img src={iconDark} alt="Icono XCoin Dark" className="sidebar-icon" />
            ) : (
              <img src={iconLight} alt="Icono XCoin Light" className="sidebar-icon" />
            )}
          </>
        ) : (
          <>
            {theme === 'dark' ? (
              <img src={logoDark} alt="Logo XCoin Dark" className="sidebar-logo-full" />
            ) : (
              <img src={logoLight} alt="Logo XCoin Light" className="sidebar-logo-full" />
            )}
          </>
        )}
      </a>

      <div className="version-tag">
        v{packageJson.version}-fix
      </div>
      <nav className="sidebar-nav">
        <ul>
          {/* v1.3.1 - 2025.12.09 [Dashboard] */}
          <li>
            <NavLink to="/" end>
              <img src={dashboardIconUrl} alt="Dashboard" className="menu-icon" />
              {!isCollapsed && <span>Dashboard</span>}
            </NavLink>
          </li>

          {/* Mercado */}
          <li
            className="menu-item-with-submenu"
            onMouseEnter={() => handleMouseEnter('mercado')}
            onMouseLeave={handleMouseLeave}
          >
            <div className="menu-item" onClick={() => handleMenuClick('mercado')}>
              <div className="menu-item-label">
                <img src={mercadoIconUrl} alt="Mercado" className="menu-icon" />
                {!isCollapsed && <span> Mercado</span>}
              </div>
              {!isCollapsed && <span className={`arrow ${openMenu === 'mercado' ? 'open' : ''}`}>▼</span>}
            </div>
            <ul className={`submenu ${openMenu === 'mercado' ? 'open' : ''}`}>
              <li>
                <NavLink to="/mercado/comprar-vender">
                  <img src={comprarVenderIconUrl} alt="Comprar y Vender" className="menu-icon" />
                  <span> Comprar y Vender</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/mercado/estado-xcoin">
                  <img src={estadoXCoinIconUrl} alt="Estado XCoin" className="menu-icon-xcoin" />
                  <span> Estado XCoin</span>
                </NavLink>
              </li>
            </ul>
          </li>

          {/* Mi Billetera */}
          <li
            className="menu-item-with-submenu"
            onMouseEnter={() => handleMouseEnter('billetera')}
            onMouseLeave={handleMouseLeave}
          >
            <div className="menu-item" onClick={() => handleMenuClick('billetera')}>
              <div className="menu-item-label">
                <img src={billeteraIconUrl} alt="Mi Billetera" className="menu-icon" />
                {!isCollapsed && <span> Mi Billetera</span>}
              </div>
              {!isCollapsed && <span className={`arrow ${openMenu === 'billetera' ? 'open' : ''}`}>▼</span>}
            </div>
            <ul className={`submenu ${openMenu === 'billetera' ? 'open' : ''}`}>
              <li>
                <NavLink to="/billetera/balance">
                  <img src={balanceIconUrl} alt="Balance y Movimientos" className="menu-icon" />
                  <span>Balance y Movimientos</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/billetera/bonos">
                  <img src={graficosIconUrl} alt="Bonos" className="menu-icon" />
                  <span>Bonos (Invita y Gana)</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/billetera/depositar-retirar">
                  <img src={depositarIconUrl} alt="Depósitos y Retiros CLP" className="menu-icon" />
                  <span>Depositar y Retirar</span>
                </NavLink>
              </li>
            </ul>
          </li>



          {/* --- Trading Automatizado --- */}
          <li className={location.pathname === '/trading-automatizado' ? 'active' : ''}>
            <Link to="/trading-automatizado" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
              <img src={comprarVenderIconUrl} alt="Trading Automatizado" className="menu-icon" />
              {!isCollapsed && (
                <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }}>
                  <span>Trading Automatizado</span>
                  <span style={{ fontSize: '0.75rem', opacity: 0.7 }}>Renta Variable</span>
                </div>
              )}
            </Link>
          </li>

          {/* --- Staking XCOIN (Renta Fija) --- */}
          <li className={location.pathname === '/inversiones' ? 'active' : ''}>
            <Link to="/inversiones" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
              <img src={depositarIconUrl} alt="Staking XCOIN" className="menu-icon" />
              {!isCollapsed && (
                <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }}>
                  <span>Staking XCOIN</span>
                  <span style={{ fontSize: '0.75rem', opacity: 0.7 }}>Renta Fija</span>
                </div>
              )}
            </Link>
          </li>

          {/* Noticias (enlace externo al sitio público) */}
          <li>
            <a href="https://xcoin.cl/blog/" target="_blank" rel="noopener noreferrer">
              <img src={noticiasIconUrl} alt="Noticias" className="menu-icon" />
              {!isCollapsed && <span>Noticias</span>}
            </a>
          </li>

          {/* --- Panel Admin (Solo Owner) --- */}
          {userData && userData.email === 'owner@xcoin.cl' && (
            <li className={location.pathname === '/admin' ? 'active' : ''}>
              <Link to="/admin" style={{ textDecoration: 'none', color: '#ffd700', display: 'flex', alignItems: 'center' }}>
                <div className="menu-icon" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <FaUserShield size={20} />
                </div>
                {!isCollapsed && <span>Panel Admin</span>}
              </Link>
            </li>
          )}

          {/* --- Cerrar Sesión (Mobile Friendly) --- */}
          <li style={{ marginTop: 'auto', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '10px' }}>
            <a
              href="/"
              onClick={async (e) => {
                e.preventDefault();
                try {
                  const { signOut } = await import("firebase/auth");
                  const { auth } = await import('../firebaseConfig');
                  await signOut(auth);
                  const marketingAppUrl = import.meta.env.VITE_MARKETING_APP_URL || 'http://localhost:5173/';
                  window.location.href = marketingAppUrl;
                } catch (error) {
                  console.error("Error al cerrar sesión", error);
                }
              }}
              style={{ textDecoration: 'none', color: '#ff4d4d', display: 'flex', alignItems: 'center' }}
            >
              <div className="menu-icon" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <span style={{ fontSize: '20px' }}>🚪</span>
              </div>
              {!isCollapsed && <span>Cerrar Sesión</span>}
            </a>
          </li>

        </ul>
      </nav >


    </aside >
  );
};

export default LeftSidebar;
